import isFunction from "lodash/isFunction";
import { useMemo } from "react";
import { Field, useFormState } from "react-final-form";

import Flx from "../../layout/Flx";
import RffInputWrapper from "../shared/RffInputWrapper";
import HtmlEditor from "../../html/HtmlEditor";

const RffBasicHtmlEditor = ({
  label,
  required = false,
  suppressGrid,
  size,
  helperText,
  testing,
  name = "htmlString",
  disabled,
  placeholder = "Start typing to add new comment... (Or paste images directly with Ctrl+V)",
  sx,

  onChange,
}) => {
  // Subscribe so we can see true initialValues (even if async)
  const { initialValues } = useFormState({
    subscription: { values: true, initialValues: true },
  });

  const styles = useMemo(() => {
    return {
      border: "1px solid #dde0e4",
      borderRadius: "6px",
      overflow: "hidden",
      position: "relative",
      ...sx,
    };
  }, [sx]);
  return (
    <RffInputWrapper
      label={label}
      suppressGrid={suppressGrid}
      size={size}
      testing={testing}
      required={required}
      helperText={helperText}
    >
      <Flx column fw gap={0} sx={styles}>
        <Field
          name={name}
          initialValue={initialValues?.htmlString || ""}
          subscription={{
            value: true,
            initial: true,
            error: true,
            touched: true,
          }}
          render={({ input, meta }) => {
            // Only use the initial value, don't pass input.value which changes on every keystroke
            const initialHtml = meta.initial || initialValues?.htmlString || "";

            return (
              <HtmlEditor
                // Use a stable key based on initial value to force remount only when form resets
                key={`editor-${meta.initial || "empty"}`}
                minHeight={60}
                value={initialHtml} // Pass initial value only
                suppressOuterBorder
                disabled={disabled}
                placeholder={placeholder}
                onChange={(v) => {
                  // Update Final Form without triggering re-render of HtmlTextEditor
                  const newHtml =
                    typeof v === "string" ? v : v?.htmlString || "";
                  input.onChange(newHtml);
                  if (isFunction(onChange)) onChange(v);
                }}
                error={meta.touched && !!meta.error}
                helperText={meta.touched && meta.error}
              />
              // <HtmlTextEditor
              //   // Use a stable key based on initial value to force remount only when form resets
              //   key={`editor-${meta.initial || "empty"}`}
              //   value={initialHtml} // Pass initial value only
              //   suppressOuterBorder
              //   disabled={disabled}
              //   placeholder={placeholder}
              //   onChange={(v) => {
              //     // Update Final Form without triggering re-render of HtmlTextEditor
              //     const newHtml =
              //       typeof v === "string" ? v : v?.htmlString || "";
              //     input.onChange(newHtml);
              //     if (isFunction(onChange)) onChange(v);
              //   }}
              //   error={meta.touched && !!meta.error}
              //   helperText={meta.touched && meta.error}
              // />
            );
          }}
        />
      </Flx>
    </RffInputWrapper>
  );
};

/**
 * Attachment utility row (unchanged)
 */



export default RffBasicHtmlEditor;
